










































import { component } from "vue/types/umd";

export default {
  name: "Header",
};
